export const writeEmailHeaderText = "Iab";
export const emailListHeaderText = "Jab";
export const readEmailHeaderText = "Kab";
export const goToHeaderText = "Lab";
export const emailActionsHeaderText = "Mab";
export const goToQuickSwitcher = "Nab";
export const newEmailCommand = "Oab";
export const sendEmailCommand = "Pab";
export const replyEmailCommand = "Qab";
export const replyAllEmailCommand = "Rab";
export const forwardEmailCommand = "Sab";
export const saveDraftCommand = "Tab";
export const discardDraftCommand = "Uab";
export const goToInboxCommand = "Vab";
export const goToDraftsCommand = "Wab";
export const goToSentCommand = "Xab";
export const searchEmailCommand = "Yab";
export const undoCommand = "Zab";
export const clearAllMessagesCommand = "_ab";
export const homeCommand = "$ab";
export const endCommand = "abb";
export const deleteEmailCommand = "bbb";
export const openEmailCommand = "cbb";
export const openEmailInNewWindowCommand = "dbb";
export const closeEmailCommand = "ebb";
export const openNextItemCommand = "fbb";
export const openPreviousItemCommand = "gbb";
export const focusNextItemPartCommand = "hbb";
export const focusPreviousItemPartCommand = "ibb";
export const expandCollapseConversationCommand = "jbb";
export const expandConversationCommand = "kbb";
export const collapseConversationCommand = "lbb";
export const softDeleteCommand = "mbb";
export const newFolderCommand = "nbb";
export const markReadCommand = "obb";
export const markUnreadCommand = "pbb";
export const flagEmailCommand = "qbb";
export const archiveCommand = "rbb";
export const markJunkCommand = "sbb";
export const categorize = "tbb";
export const insertHyperlinkCommand = "ubb";
export const showKeyboardShortcutsCommand = "vbb";
export const toggleSelectMessageCommand = "wbb";
export const quickStepCommand = "xbb";
export default {writeEmailHeaderText,emailListHeaderText,readEmailHeaderText,goToHeaderText,emailActionsHeaderText,goToQuickSwitcher,newEmailCommand,sendEmailCommand,replyEmailCommand,replyAllEmailCommand,forwardEmailCommand,saveDraftCommand,discardDraftCommand,goToInboxCommand,goToDraftsCommand,goToSentCommand,searchEmailCommand,undoCommand,clearAllMessagesCommand,homeCommand,endCommand,deleteEmailCommand,openEmailCommand,openEmailInNewWindowCommand,closeEmailCommand,openNextItemCommand,openPreviousItemCommand,focusNextItemPartCommand,focusPreviousItemPartCommand,expandCollapseConversationCommand,expandConversationCommand,collapseConversationCommand,softDeleteCommand,newFolderCommand,markReadCommand,markUnreadCommand,flagEmailCommand,archiveCommand,markJunkCommand,categorize,insertHyperlinkCommand,showKeyboardShortcutsCommand,toggleSelectMessageCommand,quickStepCommand};